"use strict";

Shopify.theme.jsIconSlider = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsIconSlider = $.extend(this, Shopify.theme.getSectionData($section)); // Selectors

    var $slider = $section.find('.shop-by-category__slider');
    $slider.slick({
      infinite: true,
      slidesPerRow: 1,
      slidesToShow: 6,
      slidesToScroll: 2,
      arrows: false,
      centerMode: false,
      speed: 100,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 5
          }
        },
        {
          breakpoint: 480,
          settings: "unslick"
          // settings: {
          //   // slidesToShow: 2,
          //   // centerMode: true,
          //   // centerPadding: '60px'
          //   rows: 2,
          //   slidesToShow: 8,
          //   slidesPerRow: 2,
          //   variableWidth: true
          // }
        }
      ]
    });

  },
  unload: function unload($section) {
    
  }
};